import ServicesShowcase from '@/components/ServicesShowcase'

export const ServicesSection = () => {
  return (
    <section
      id='services'
      className='pt-16'
    >
      <div className='container mx-auto px-4'>
        <ServicesShowcase />
      </div>
    </section>
  )
}
